import { Stack } from '@mui/material';

import Modal from 'components/v2/modal/Modal';
import { TASKS_MODAL_ID } from 'constants/ui/modal';
import { MODAL_WIDTH } from 'constants/ui/style';
import { TaskStatus } from 'api';
import TaskModalTitle from 'components/v2/shared/TaskModalTitle';
import React from 'react';
import SkeletonContainer from 'components/v2/container/SkeletonContainer';
import type { DetailFormProps, QuestionnaireFormProps } from './AITextInputTaskModalContent';

import { useAITextInputTaskModal } from 'hooks/services/useAITextInputTaskModal';

const AITextInputTaskModal = () => {
  const {
    isQuestionnaireAvailable,
    t,
    reference,
    taskStatus,
    activeStep,
    isMutateLoading,
    isQuestionnaireLoading,
    steps,
    detailsFormData,
    detailFormRef,
    questionnaireFormRef,
    setIsQuestionnaireAvailable,
    handleDetailsFormSubmit,
    handleClickConfirm,
    handleClickCancel,
    setIsQuestionnaireSubmitting,
    isModalOpen,
    toggleModal,
  } = useAITextInputTaskModal();

  return (
    <Modal
      isOpen={isModalOpen(TASKS_MODAL_ID.AITextInput)}
      toggleModal={() => toggleModal(TASKS_MODAL_ID.AITextInput)}
      modalTitle={<TaskModalTitle title={t('modals.aiText.title')} caseId={reference ?? ''} />}
      width={MODAL_WIDTH.md}
      hideFooter={taskStatus === TaskStatus.Complete}
      onConfirm={handleClickConfirm}
      onCancel={handleClickCancel}
      confirmBtnLabel={
        activeStep === 1 || !isQuestionnaireAvailable ? t('common.actions.confirm') : t('navigation.next')
      }
      cancelBtnLabel={activeStep !== 0 ? t('navigation.back') : t('common.actions.cancel')}
      isLoading={isMutateLoading}
    >
      <SkeletonContainer columns={{ xs: 1 }} rows={{ xs: 1 }} loading={isQuestionnaireLoading}>
        <Stack gap="1.25rem">
          {activeStep === 0 &&
            React.cloneElement(
              (steps[0] as { renderContent: (props: DetailFormProps) => React.ReactElement }).renderContent({
                initialData: detailsFormData,
                isSendEmailAvailable: true,
                onQuestionnaireChange: setIsQuestionnaireAvailable,
                onSubmit: handleDetailsFormSubmit,
              }) as React.ReactElement<any>,
              { ref: detailFormRef }
            )}
          {activeStep === 1 &&
            React.cloneElement(
              (
                steps[1] as unknown as { renderContent: (props: QuestionnaireFormProps) => React.ReactElement }
              ).renderContent({ setIsSubmitting: setIsQuestionnaireSubmitting }) as React.ReactElement<any>,
              { ref: questionnaireFormRef }
            )}
        </Stack>
      </SkeletonContainer>
    </Modal>
  );
};
export default AITextInputTaskModal;
